import _ from 'lodash';
import errorSkeleton from "../../../libs/errorSkeleton";
import axios from "axios";
import {apiUrl} from '../../../libs/api';

// import Uploader from "./UploaderLib";

export default class UploaderLib {
    static fileConvertSize = (aSize) => {
        aSize = Math.abs(parseInt(aSize, 10));
        let def = [[1, 'octets'], [1024, 'ko'], [1024 * 1024, 'Mo'], [1024 * 1024 * 1024, 'Go'], [1024 * 1024 * 1024 * 1024, 'To']];
        for (let i = 0; i < def.length; i++) {
            if (aSize < def[i][0]) return (aSize / def[i - 1][0]).toFixed(2) + ' ' + def[i - 1][1];
        }
    };

    static defaultStatus = {
        intervalTime: 0,
        intervalSize: 0,
        delta: 0,
        kos: 0,
        percentCompleted: 0,
        eta: 0,
        lastEtas: [],
        lastKos: []
    };

    constructor({
                    uploadPath = null,
                }) {
        this.file = null;
        this.uploading = false;
        this.source = {};
        this.status = UploaderLib.defaultStatus;
        this.uploadPath = uploadPath;
        if (!this.uploadPath) console.error('Aucun path d\'upload dans FileUpload')
        this.defaultImg = "data:image/jpeg;base64,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";
    }

    _progress(status, progressCb) {
        let previous = {...this.status};
        let intervalTime = 0;
        let intervalSize = 0;
        let delta = 0;
        let kos = 0;
        let eta = 0;
        let lastEtas = previous.lastEtas || [];
        let lastKos = previous.lastKos || [];

        if (previous.timeStamp > 0) {
            intervalTime = status.timeStamp - previous.timeStamp;
            intervalSize = status.loaded - previous.loaded;
            delta = 1 / intervalTime;
            kos = Math.floor(intervalSize * delta);
            eta = Math.floor((status.total - status.loaded) / _.mean(lastKos));
            lastEtas = [...lastEtas, eta || 0].slice(-3);
            lastKos = [...lastKos, kos || 0].slice(-10);
        }

        this.status = {
            loaded: status.loaded,
            total: status.total,
            timeStamp: status.timeStamp,
            percentCompleted: Math.round((status.loaded * 100) / status.total),
            lastEtas,
            lastKos,
            eta: Math.round(_.mean(lastEtas)) || 0,
            kos: Math.round(_.mean(lastKos)) || 0
        };

        progressCb(this.status);
    }

    upload(data, progressCb = () => {
    }) {
        if (this.file && !this.uploading) {
            this.uploading = true;
            this.status = UploaderLib.defaultStatus;
            let formData = new FormData();
            formData.append("jsonData", JSON.stringify(data));
            formData.append('file', this.file);
            return apiUrl.post(
                this.uploadPath,
                formData,
                {
                    timeout: 3600000,
                    cancelToken: this.source.token,
                    onUploadProgress: (progressEvent) => this._progress(progressEvent, progressCb)
                }
            ).then(res => {
                this.uploading = false;
                if(_.get(this.file,"ephemeralId")){
                    res.ephemeralId = this.file.ephemeralId;
                }
                return res;
            }).catch(err => {
                this.uploading = false;
                throw err;
            });
        }
        else if (!this.file) {
            let error = {
                ...errorSkeleton,
                errors: {
                    noFile: true,
                }
            };
            throw error;
        }
    }

    cancel() {
        if (this.source.cancel) this.source.cancel('canceled');
    }

    uid = function(len = 0){
        len = parseInt(len);
        len = len === 0 ? 10 : len;
        return Date.now().toString(36) + Math.random().toString(36).substr(2,len);
    }


    load(file) {

        return new Promise((resolve, reject) => {
            let fileReader = new FileReader();
            let error = {
                ...errorSkeleton,
                errors: {
                    noFile: !file,
                }
            };
            if (error.errors.noFile) reject(error);
            else {
                this.source = axios.CancelToken.source();
                this.file = file;
                this.file.ephemeralId = this.uid(15);
                let type = file.type.substr(0, 5);
                fileReader.readAsDataURL(file);
                fileReader.onloadend = () => resolve({file, preview: type === "video" ? this.defaultImg : fileReader.result});
            }
        });
    }
}